import React from 'react';
//import {Link} from 'react-router-dom';
import { Main } from '../../layout';
import NotFoundPage from './NotFoundPage';

const NotFound = () => (<Main>
    <section className="not-found">
        <div className="container">
            <img className="img-fluid" src="/images/not-found.jpg"/>
        </div>
    </section>
</Main>);
export default NotFound;
